import find from "lodash/find";
import isNumber from "lodash/isNumber";
import orderBy from "lodash/orderBy";
import take from "lodash/take";
import { getAttribute } from "PFCore/helpers/get_attribute";
import { roundToDecimals } from "PFCore/helpers/rounding";
import { AvailabilityDuration, AvailabilityMode, AvailabilityRange, DurationMode } from "PFTypes";
import { Phase } from "PFTypes/phase";
import { TFunction } from "react-i18next";

export const getDurationText = (
  duration: AvailabilityDuration,
  mode: AvailabilityMode,
  t: TFunction<["core", "translation"]>
): string => {
  const periodLabels: Partial<Record<AvailabilityMode, string>> = {
    [AvailabilityMode.Within]: t("translation:availabilityRequirement.withinPeriod"),
    [AvailabilityMode.PerWeek]: t("translation:availabilityRequirement.perWeek"),
    [AvailabilityMode.PerMonth]: t("translation:availabilityRequirement.perMonth")
  };
  const period = periodLabels[mode] ?? "";

  if (duration.mode === DurationMode.Days) {
    return `${t("core:time.inWords.days", { count: duration.value })} ${period}`.trim();
  }

  const count = roundToDecimals(duration.value / 60);
  return `${t("core:time.inWords.hours", { count })} ${period}`.trim();
};

export const getVisibleRangesData = (ranges: AvailabilityRange[], rangesLimit?: number) => {
  const rangesToDisplay = isNumber(rangesLimit) ? take(ranges, rangesLimit) : ranges;
  const isAnyRangeHidden = rangesToDisplay.length < ranges.length;

  return {
    rangesToDisplay,
    isAnyRangeHidden
  };
};

export const getSortedRanges = (ranges: AvailabilityRange[]) =>
  orderBy(ranges, ({ start }) => new Date(start || "").getTime());

export const getRangePhaseText = (phases: Phase[], range: AvailabilityRange) =>
  find(phases, { sourceId: getAttribute(range, "phase_source_id") })?.name;

export const getFormattedRangeDates = (range: AvailabilityRange, formatDate: (date: string) => string) =>
  `${formatDate(range.start || "")} - ${formatDate(range.end || "")}`;
